/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const config = {};

config.cookie_first = null;
// config.google_tag_manager = null;
config.adobe_analytics = true;
config.hotjar = null;

export default config;
